<template>
  <div id="app">
    <!-- <XxCouplet class="xx-couplet"></XxCouplet> -->
    <HelloWorld @closeCouplet="close" />
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
// import XxCouplet from "./components/XxCouplet.vue";

export default {
  name: "App",
  components: {
    HelloWorld,
    // XxCouplet,
  },
  mounted() {
    // this.getCanvas();
  },
  methods: {
    close(val) {
      if (val == 1) {
        document.querySelector(".xx-couplet").style.display = "none";
      } else {
        document.querySelector(".xx-couplet").style.display = "block";
      }
    },
  },
};
</script>

<style>
/* 确保 html 和 body 占据全屏 */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  /* overflow: hidden; 可选，防止出现滚动条 */
}

#app {
  width: 100%;
  height: 100%;
  background: url("@/assets/banner-bg.png") no-repeat center center;
  background-size: cover; /* 确保背景图完全覆盖 */
}
.xx-couplet {
  position: absolute;
}
</style>
